import { render, staticRenderFns } from "./receiptInfo.vue?vue&type=template&id=1360ae58&scoped=true"
import script from "./receiptInfo.vue?vue&type=script&lang=js"
export * from "./receiptInfo.vue?vue&type=script&lang=js"
import style0 from "./receiptInfo.vue?vue&type=style&index=0&id=1360ae58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1360ae58",
  null
  
)

export default component.exports